import React, { useState } from 'react';
import { Button, Form, Alert, Card, Row, Col, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';


const Authentication = () => {
  const navigate = useNavigate();
  const { login, logout, isAuthenticated, user, loading, error: authError } = useAuth();
  const [credentials, setCredentials] = useState({
    email: 'admin1@example.com',
    password: 'Admin123!@#',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials({
      ...credentials,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      await login(credentials);
      setSuccess('Successfully logged in!');
      navigate('/');
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'Invalid email or password');
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      setSuccess('Successfully logged out!');
      setCredentials({ email: '', password: '' });
    } catch (err) {
      setError('Error during logout, but session was cleared');
    }
  };

  // Show server offline banner if that's the error
  const isServerOffline = error?.includes('server is currently offline') || authError?.includes('server is currently offline');

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (isServerOffline) {
    return (
      <div className="position-fixed top-0 start-0 w-100" style={{ zIndex: 1050 }}>
        <Alert variant="danger" className="m-0 text-center py-3">
          <h4 className="alert-heading mb-2">⚠️ Server Offline</h4>
          <p className="mb-0">The backend server is currently offline. Please try again later.</p>
        </Alert>
      </div>
    );
  }

  if (isAuthenticated && user) {
    return (
      <Card className="mx-auto shadow-sm" style={{ maxWidth: '600px' }}>
        <Card.Body className="p-4">
          <Row className="align-items-center mb-4">
            <Col>
              <h2>Welcome, {user.displayName || user.email}</h2>
            </Col>
            <Col xs="auto">
              <Button 
                variant="outline-danger" 
                onClick={handleLogout}
                disabled={loading}
              >
                {loading ? 'Processing...' : 'Logout'}
              </Button>
            </Col>
          </Row>

          <Card className="mb-4">
            <Card.Body>
              <h5 className="mb-3">User Details</h5>
              <Row>
                <Col md={6}>
                  <p><strong>User ID:</strong> {user.uid}</p>
                  <p><strong>Email:</strong> {user.email}</p>
                  <p><strong>Role:</strong> {Array.isArray(user.roles) ? user.roles.join(', ') : user.role}</p>
                </Col>
                <Col md={6}>
                  <p><strong>Last Login:</strong> {user.lastLogin ? new Date(user.lastLogin).toLocaleString() : '—'}</p>
                  <p><strong>Session Status:</strong> Active</p>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {success && <Alert variant="success">{success}</Alert>}
          {(error || authError) && !isServerOffline && <Alert variant="danger">{error || authError}</Alert>}
        </Card.Body>
      </Card>
    );
  }

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={6}>
          <Card>
            <Card.Header as="h5">Login</Card.Header>
            <Card.Body>
              {(error || authError) && !isServerOffline && <Alert variant="danger">{error || authError}</Alert>}
              {success && <Alert variant="success">{success}</Alert>}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={credentials.email}
                    onChange={handleInputChange}
                    placeholder="Enter email"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    value={credentials.password}
                    onChange={handleInputChange}
                    placeholder="Password"
                    required
                  />
                </Form.Group>

                <Button 
                  variant="success" 
                  type="submit" 
                  disabled={loading}
                  className="w-100"
                >
                  {loading ? 'Processing...' : 'Login'}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Authentication; 